import React from "react";
import { Link } from "react-router-dom";
import mashhadLogo from "../../assets/images/mashhad-logo.png";
import supportingAppLogo from "../../assets/images/supporting-apps.svg";
import dashboardLogo from "../../assets/images/dashboard.svg";
import { useTranslation } from "react-i18next";
import { logActivity } from "../../helpers/activityLog";

import "./Home.scss";
import Chatbot from "../../components/Chatbot/Chatbot";

const Home = () => {
  const { t } = useTranslation();
  return (
    <div className='home'>
      <Chatbot />
      {/* <div className='chatbot'>
        <BotIcon width={24} height={24} />
        <p>Get chatbot help</p>
        <ArrowRightIcon width={24} height={24} />
      </div> */}
      <div className='left'></div>
      <div className='right'>
        <h1>
          <div>{t("Mashhad")}</div>
          <div>{t("Municipality Projects")}</div>
        </h1>
        <div className='apps'>
          <a
            href='/mashhad'
            className='app'
            onClick={() =>
              logActivity({
                eventCategory: "National Campaign",
                eventDescription: "Opened National Campaign from Landing Page",
                moduleName: "National Campaign",
              })
            }
          >
            <div className='app_img'>
              <img src={mashhadLogo} alt='Mashhad Logo' />
            </div>
            <div className='app_content'>
              <h5>{t("National Campaign")}</h5>
              <p>{t("KPIs & statistics of national campaign")}</p>
            </div>
          </a>

          <a
            href='/SupervisionStreams'
            className='app'
            onClick={() =>
              logActivity({
                eventCategory: "Supervision Streams",
                eventDescription:
                  "Opened Supervision Streams from Landing Page",
                moduleName: "Supervision Streams",
              })
            }
          >
            <div className='app_img'>
              <img src={mashhadLogo} alt='SS Logo' />
            </div>
            <div className='app_content'>
              <h5>{t("Supervision Streams")}</h5>
              <p>{t("KPIs & statistics of supervision streams")}</p>
            </div>
          </a>

          <Link
            to='/SupportingApp'
            className='app'
            onClick={() =>
              logActivity({
                eventCategory: "Supporting Program",
                eventDescription:
                  "Opened Supporting Program from Landing Page",
                moduleName: "Supporting Program",
              })
            }
          >
            <div className='app_img'>
              <img src={supportingAppLogo} alt='SA Logo' />
            </div>
            <div className='app_content'>
              <h5>{t("Supporting Program")}</h5>
              <p>{t("Supporting web applications of Mashhad")}</p>
            </div>
          </Link>

          <Link
            to='/dashboards'
            className='app'
            onClick={() =>
              logActivity({
                eventCategory: "Dashboards",
                eventDescription: "Opened Dashboards from Landing Page",
                moduleName: "Dashboards",
              })
            }
          >
            <div className='app_img'>
              <img src={dashboardLogo} alt='SS Logo' />
            </div>
            <div className='app_content'>
              <h5>{t("Dashboards")}</h5>
              <p>Power BI Dashboards</p>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Home;
